import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "smsToggle", "smsStatusLabel", "smsTerms", "smsToggleWrapper"];

  toggleConfirmationModal(eventCheckbox) {
    if (!eventCheckbox.target.checked) {
      eventCheckbox.preventDefault();
      $('#preferenceToggleConfirmationModal .modal-body').text(eventCheckbox.params.confirmationMessage);

      $('#submitBtn').on('click', (e) => {
        eventCheckbox.target.checked = false;
        this.formTarget.requestSubmit();
      });

      $('#preferenceToggleConfirmationModal').on('hidden.bs.modal', (e) => {
        $('#submitBtn').off('click');
      });

      $('#preferenceToggleConfirmationModal').modal('show');
    } else {
      this.formTarget.requestSubmit();
    }
  }

  handleChange(e) {
    e.target.form.requestSubmit()
  }

  handleSmsTermsChange(e) {
    const agreed = e.target.checked
    if (this.hasSmsToggleTarget) {
      this.smsToggleTarget.disabled = !agreed
      this.smsToggleTarget.checked = agreed
      if (this.hasSmsStatusLabelTarget) {
        this.smsStatusLabelTarget.textContent = agreed ? 'On' : 'Off'
        this.smsStatusLabelTarget.style.color = agreed ? '#4168FF' : '#727272'
      }
    }
    if (this.hasSmsToggleWrapperTarget) {
      const $wrapper = $(this.smsToggleWrapperTarget)
      $wrapper.tooltip('dispose')
      if (agreed) {
        $wrapper.removeAttr('title')
      } else {
        $wrapper.attr('title', 'Agree to the terms below to enable')
        $wrapper.tooltip()
      }
    }
    e.target.form.requestSubmit()
  }

}
